import { useEffect, useMemo, useState } from 'react';
import {
  CoveredEntityListPage as SharedCoveredEntityListPage,
  createPatientTrackingCsvImportConfig
} from '@jarvis/platform-ui';
import {
  listClientPortalTenants,
  searchClientPortalGroups
} from '../../api/clientPortalStorageMountsAdmin';
import { patientTrackingImportApi } from '../../api/patientTrackingImport';
import { showErrorToast, showSuccessToast } from '../../notifications/toast';

const coveredEntityCsvImport = createPatientTrackingCsvImportConfig(
  {
    title: 'Covered Entities',
    intro:
      'Add pharmacies in Our Pharmacies first. Each covered entity row must include a pharmacy name or GUID.',
    templateUrl: patientTrackingImportApi.coveredEntities.templateUrl,
    templateFileName: patientTrackingImportApi.coveredEntities.templateFileName,
    importCsv: patientTrackingImportApi.coveredEntities.importCsv,
    downloadTemplate: patientTrackingImportApi.coveredEntities.downloadTemplate
  },
  { showSuccess: showSuccessToast, showError: showErrorToast }
);

export function CoveredEntityListPage() {
  const [clientTenantId, setClientTenantId] = useState<string | null>(null);

  useEffect(() => {
    listClientPortalTenants()
      .then((tenants) => setClientTenantId(tenants[0]?.tenantId ?? null))
      .catch(() => setClientTenantId(null));
  }, []);

  const searchPortalAlertGroups = useMemo(
    () =>
      clientTenantId
        ? (query: string) => searchClientPortalGroups(clientTenantId, query)
        : undefined,
    [clientTenantId]
  );

  return (
    <SharedCoveredEntityListPage
      csvImport={coveredEntityCsvImport}
      searchPortalAlertGroups={searchPortalAlertGroups}
      stateStorageKey="webopsui:covered-entity-grid"
    />
  );
}
